import Footer from '@/components/layout/Footer';
import Navbar from '@/components/layout/Navbar';

export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-slate-900">
      <Navbar />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
